import React from "react";
import { useFela } from "react-fela";

import { useTheme } from "@/hooks/useTheme";
import { Heading } from "@/components/Heading";
import { Grid } from "@/components/Grid";
import { EnterpriseGradeSecurityItem } from "./EnterpriseGradeSecurityItem";
import { IEnterpriseGradeSecuritySection } from "./types";

type IProps = IEnterpriseGradeSecuritySection & JSX.IntrinsicElements["div"];

export const EnterpriseGradeSecuritySection: React.FC<IProps> = ({
  title,
  cards,
}) => {
  const { css } = useFela();
  const { bp } = useTheme();
  return (
    <Grid
      id="EnterpriseGradeSecuritySection"
      customStyle={{
        flexDirection: "column",
        alignItems: "center",
      }}
      wrapperStyle={{
        backgroundColor: "#F7F8FD",
      }}
    >
      <Heading
        as="h2"
        customStyle={{
          letterSpacing: "-0.01rem",
          textAlign: "center",
          [bp.FROM_DESKTOP]: {
            fontSize: 48,
            lineHeight: "60px",
          },
        }}
      >
        {title}
      </Heading>
      <div
        className={css({
          display: "flex",
          flexDirection: "column",
          marginTop: 30,
          backgroundColor: "#fffffe",
          boxShadow: "0px 10px 35px rgba(0, 0, 0, 0.03)",
          flexWrap: "wrap",
          borderRadius: 12,
          [bp.FROM_DESKTOP]: {
            flexDirection: "row",
            justifyContent: "center",
            marginTop: 44,
          },
        })}
      >
        {cards.map(({ id, ...rest }) => (
          <EnterpriseGradeSecurityItem key={id} {...rest} />
        ))}
      </div>
    </Grid>
  );
};
